module.exports = __webpack_public_path__ + "static/media/APP_EarlyRiser_152x174_3.f1bbb4bb.png";